module.exports = __webpack_public_path__ + "static/media/CICLO_6_GENERO_DIGITAL_2022.1c8ff686.jpg";